import { Column, Row } from 'components/Layout/Grid';
import styled from 'styled-components';

interface PeriodProps {
  isMobile: boolean;
}

export const PeriodRow = styled(Row) <PeriodProps>`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
  margin-right: 0.5rem;

  ${(props) =>
    props.isMobile &&
    `
    justify-content: space-around;
  `}
`;

export const PeriodColumn = styled(Column) <PeriodProps>`
  margin-right: 0.5rem;

  ${(props) =>
    props.isMobile &&
    `
    margin-top: 2px;
  `}
`;

export const TableSearchOrderContent = styled(Row) <PeriodProps>`
  margin-top: 1.6em;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 10px 0px;
  background: #fff;

  ${(props) =>
    props.isMobile && `
    margin-top: 0;
    flex-direction: column;
    align-items: unset;
  `}
`;

export const TableSearchOrderFocusBtn = styled.button<PeriodProps>`
  border: 2px solid #bebebe;
  border-radius: 6px;

  &:focus {
    border: 2px solid #0e4c54;

    img {
      filter: invert(38%) sepia(86%) saturate(5325%) hue-rotate(145deg) brightness(88%) contrast(105%);
    }
  }

  width: 42px;
  height: 42px;

  ${(props) =>
    props.isMobile && `
      padding: 0;
      width: 100px;
      height: 42px;
      margin: 0 auto;
  `}
`;
